import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import Page from '../../components/Page';
import client from '../../lib/feathers';

export default function Broadcasts() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await client.service('admin/user-broadcast').find({
          query: { $limit: 50 },
        });
        if (!cancelled) setRows(res.data || []);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load broadcasts');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <Page title="User Broadcasts">
      <div className="mx-auto max-w-6xl">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-semibold">User Broadcasts</h1>
            <p className="text-sm text-gray-600 mt-1">
              Email every user opted-in to a notification preferences category.
              Every send adds an unsubscribe footer linking to
              <code className="mx-1 px-1 bg-gray-100 rounded">/me/notifications</code>.
            </p>
          </div>
          <Link
            to="/admin/broadcasts/new"
            className="inline-flex items-center px-4 py-2 bg-red-700 text-white rounded-md text-sm font-medium hover:bg-red-800"
          >
            Compose New Broadcast
          </Link>
        </div>

        {loading && <p className="text-gray-500">Loading…</p>}
        {error && !loading && <p className="text-red-700">{error}</p>}
        {!loading && !error && rows.length === 0 && (
          <p className="text-gray-500">No broadcasts have been sent yet.</p>
        )}
        {!loading && rows.length > 0 && (
          <div className="overflow-x-auto bg-white shadow rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">When</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Category</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Subject</th>
                  <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Recipients</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Sent by</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td className="px-4 py-3 text-sm text-gray-700">
                      {row.sentAt ? formatDistanceToNow(new Date(row.sentAt), { addSuffix: true }) : '—'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700">{row.eventKey}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{row.subject}</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-700">{row.recipientCount.toLocaleString()}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">
                      {row.sentByUser
                        ? `${row.sentByUser.firstName || ''} ${row.sentByUser.lastName || ''}`.trim() || row.sentByUser.email
                        : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Page>
  );
}
